export const NODE_TYPE = 'node' as const;

export const DEFAULT_SYMBOL_SIZE = 34;
export const DEFAULT_REPLUSION = 480;
export const DEFAULT_EDGE_LENGTH = 120;
